var actionCallbackMap = new Map();
function getCallbackMap(componentKey) {
    return actionCallbackMap.get(componentKey);
}
export function onComponentEventAction(_a, iEventName, callback) {
    var key = _a.key, _b = _a.component, onEvents = _b.onEvents, name = _b.name;
    var eventName = "__impage__component-event-" + iEventName;
    if (onEvents && !onEvents.find(function (i) { return i.eventName === eventName; })) {
        console.warn("Invalid on event type [" + eventName + "] inside component [" + name + "]");
        return;
    }
    var map = getCallbackMap(key);
    if (!map) {
        return actionCallbackMap.set(key, new Map([[eventName, [callback]]]));
    }
    var callbacks = map.get(eventName);
    if (!callbacks) {
        return map.set(eventName, [callback]);
    }
    callbacks.push(callback);
}
export function offComponentEventAction(_a, iEventName, callback) {
    var key = _a.key;
    var eventName = "__impage__component-event-" + iEventName;
    var map = getCallbackMap(key);
    if (!map) {
        return;
    }
    var callbacks = map.get(eventName);
    if (!callbacks) {
        return map.delete(eventName);
    }
    var index = callbacks.findIndex(function (cb) { return cb === callback; });
    if (index > -1) {
        callbacks.splice(index, 1);
    }
}
export function getComponentEventActionCallbacks(componentKey, eventName) {
    var map = getCallbackMap(componentKey);
    if (!map) {
        return null;
    }
    return map.get(eventName);
}
export function clearComponentEventActionCallbackMap() {
    return actionCallbackMap.clear();
}
//# sourceMappingURL=componentEventActionEmitter.js.map